import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=181cf28c&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=181cf28c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181cf28c",
  null
  
)

export default component.exports